// extracted by mini-css-extract-plugin
export default {"jobListFooterContainer":"JobListFooter_jobListFooterContainer__Bcy1Q"};